/*
 * Canvas compatibility for Android System WebView builds that are old enough
 * to run the game but do not have CanvasRenderingContext2D.roundRect (Chrome
 * 99+). The textures use it for painted signs and vehicle decals, so without
 * this fallback the level build stops with "roundRect is not a function".
 *
 * This follows the native behaviour closely enough for the game: it appends a
 * closed rounded-rectangle subpath to the current path and supports either one
 * radius or the four-value corner array.
 */
if (
  typeof CanvasRenderingContext2D !== 'undefined' &&
  typeof CanvasRenderingContext2D.prototype.roundRect !== 'function'
) {
  CanvasRenderingContext2D.prototype.roundRect = function roundRect(
    x,
    y,
    width,
    height,
    radii,
  ) {
    const fallback = 0;
    const values = Array.isArray(radii) ? radii : [radii, radii, radii, radii];
    const [
      topLeft = fallback,
      topRight = fallback,
      bottomRight = fallback,
      bottomLeft = fallback,
    ] = values.map((value) => Math.max(0, Number(value) || 0));

    const limit = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    const tl = Math.min(topLeft, limit);
    const tr = Math.min(topRight, limit);
    const br = Math.min(bottomRight, limit);
    const bl = Math.min(bottomLeft, limit);

    this.moveTo(x + tl, y);
    this.lineTo(x + width - tr, y);
    this.quadraticCurveTo(x + width, y, x + width, y + tr);
    this.lineTo(x + width, y + height - br);
    this.quadraticCurveTo(x + width, y + height, x + width - br, y + height);
    this.lineTo(x + bl, y + height);
    this.quadraticCurveTo(x, y + height, x, y + height - bl);
    this.lineTo(x, y + tl);
    this.quadraticCurveTo(x, y, x + tl, y);
    this.closePath();
  };
}
